import React, { useState, useEffect } from 'react';
import { Route, Switch, Redirect } from "react-router-dom";
import { Routes } from "../routes";

// pages
// import Presentation from "./Presentation";
import DashboardOverview from "./dashboard/DashboardOverview";
import Vendors from './Vendor/Vendors';
import Settings from "./Settings";
import Signin from "./examples/Signin";
import Signup from "./examples/Signup";
import ForgotPassword from "./examples/ForgotPassword";
import ResetPassword from "./examples/ResetPassword";
import Lock from "./examples/Lock";
import NotFoundPage from "./examples/NotFound";
import ServerError from "./examples/ServerError";
import VendorDetail from './Vendor/VendorDetail';

// components
import Sidebar from "../components/Sidebar";
import Navbar from "../components/Navbar";

import Preloader from "../components/Preloader";
import AddVendor from './Vendor/AddVendor';
import Assets from './Assets/Assets';
import AssetsAdd from './Assets/AssetsAdd';
import AssetsDetail from './Assets/AssetsDetail';
import AddReminder from './Reminders/AddReminder';
import Reminder from './Reminders/Reminder';
import ReminderDetail from './Reminders/ReminderDetail';
import FileManagement from './FileManagemet/FileManagement';
import Notifications from './Notifications/Notifications';
import Timeoff from './Timeoff/Timeoff';
import AddTimeOff from './Timeoff/AddTimeOff';
import TimeOffDetail from './Timeoff/TimeOffDetail';
import RegisterVendor from './examples/RegisterVendor';
import Contracts from './Contracts/Contracts';
import AddContracts from './Contracts/AddContracts';
import ContractsDetail from './Contracts/ContractsDetail';
import ProjectAnnoucement from './ProjectAnnoucement/ProjectAnnoucement';
import VendorsProjectAnnocement from './ProjectAnnoucement/VendorsProjectAnnocement';
import AddProjectAnnoucement from './ProjectAnnoucement/AddProjectAnnoucement';
import ProjectAnnoucementDetail from './ProjectAnnoucement/ProjectAnnoucementDetail';



const RouteWithLoader = ({ component: Component, ...rest }) => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setLoaded(true), 1000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <Route {...rest} render={props => ( <>  <Component {...props} /> </> ) } />
  );
};

const RouteWithSidebar = ({ component: Component, ...rest }) => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setLoaded(true), 1000);
    return () => clearTimeout(timer);
  }, []);

  const localStorageIsSettingsVisible = () => {
    return localStorage.getItem('settingsVisible') === 'false' ? false : true
  }

  const [showSettings, setShowSettings] = useState(localStorageIsSettingsVisible);

  const toggleSettings = () => {
    setShowSettings(!showSettings);
    localStorage.setItem('settingsVisible', !showSettings);
  }

  return (
    <Route {...rest} render={props => (
      <>
        {/* <Preloader show={loaded ? false : true} />   */}
        <Sidebar />

        <main className="content">
          <Navbar />
          <Component {...props} />
          
        </main>
      </>
    )}
    />
  );
};
// Protected Route (checks for authentication)
const ProtectedRoute = ({ component: Component, ...rest }) => {
  const isAuthenticated = !!localStorage.getItem('token'); // Check if token exists

  return (
    <Route
      {...rest}
      render={(props) =>
        isAuthenticated ? (
          <RouteWithSidebar component={Component} {...props} />
        ) : (
          <Redirect to={{ pathname: Routes.Signin.path, state: { from: props.location } }} />
        )
      }
    />
  );
};
export default () => (
  <Switch>
     <RouteWithLoader exact path={Routes.RegisterVendor.path} component={RegisterVendor} />
    <RouteWithLoader exact path={Routes.Signin.path} component={Signin} />
    <RouteWithLoader exact path={Routes.Signup.path} component={Signup} />
    <RouteWithLoader exact path={Routes.ForgotPassword.path} component={ForgotPassword} />
    <RouteWithLoader exact path={Routes.ResetPassword.path} component={ResetPassword} />
    <RouteWithLoader exact path={Routes.Lock.path} component={Lock} />
    <RouteWithLoader exact path={Routes.NotFound.path} component={NotFoundPage} />
    <RouteWithLoader exact path={Routes.ServerError.path} component={ServerError} />

    {/* pages */}

    <ProtectedRoute exact path={Routes.Notifications.path} component={Notifications} />
    <ProtectedRoute exact path={Routes.FileManagement.path} component={FileManagement} />
    <ProtectedRoute exact path={Routes.Timeoff.path} component={Timeoff} />
    <ProtectedRoute exact path={`${Routes.AddTimeOff.path}/:id`} component={AddTimeOff} />
    <ProtectedRoute exact path={Routes.AddTimeOff.path} component={AddTimeOff} />
    <ProtectedRoute exact path={`${Routes.TimeOffDetail.path}/:id`}   component={TimeOffDetail} />
    <ProtectedRoute exact path={Routes.Reminder.path} component={Reminder} />
    <ProtectedRoute exact path={`${Routes.AddReminder.path}/:id`} component={AddReminder} />
    <ProtectedRoute exact path={Routes.AddReminder.path} component={AddReminder} />
    <ProtectedRoute exact path={`${Routes.ReminderDetail.path}/:id`}  component={ReminderDetail} />
    <ProtectedRoute exact path={`${Routes.AddVendor.path}/:id`} component={AddVendor} />
    <ProtectedRoute exact  path={Routes.AddVendor.path} component={AddVendor} />
    <ProtectedRoute exact path={`${Routes.VendorDetail.path}/:id`} component={VendorDetail} />
    <ProtectedRoute exact path={Routes.Vendors.path} component={Vendors} />
    <ProtectedRoute  exact path={Routes.DashboardOverview.path} component={DashboardOverview} />
    <ProtectedRoute exact path={`${Routes.AssetsDetail.path}/:id`} component={AssetsDetail} />
    <ProtectedRoute exact path={`${Routes.AssetsAdd.path}/:id`}component={AssetsAdd} />
    <ProtectedRoute exact path={Routes.AssetsAdd.path} component={AssetsAdd} />
    <ProtectedRoute exact path={Routes.Assets.path} component={Assets} />
    <ProtectedRoute exact path={Routes.ProjectAnnoucement.path} component={ProjectAnnoucement} />
    <ProtectedRoute exact path={`${Routes.VendorsProjectAnnocement.path}/:id`} component={VendorsProjectAnnocement} />
    <ProtectedRoute exact path={Routes.AddProjectAnnoucement.path} component={AddProjectAnnoucement} />
    <ProtectedRoute exact path={`${Routes.AddProjectAnnoucement.path}/:id`}component={AddProjectAnnoucement} />
    <ProtectedRoute exact  path={`${Routes.ProjectAnnoucementDetail.path}/:id`} component={ProjectAnnoucementDetail} />
    <ProtectedRoute exact path={Routes.Contracts.path} component={Contracts} />
    <ProtectedRoute exact path={`${Routes.ContractsDetail.path}/:id`} component={ContractsDetail} />
    <ProtectedRoute exact path={`${Routes.ContractsAdd.path}/:id`}component={AddContracts} />
    <ProtectedRoute exact path={Routes.ContractsAdd.path} component={AddContracts} />
    <ProtectedRoute exact path={Routes.Settings.path} component={Settings} />
    

  


    <Redirect to={Routes.NotFound.path} />
  </Switch>
);
